export default "__VITE_ASSET__Bp9Bg9Re__"